import { render } from "./Instruments.vue?vue&type=template&id=582339be&scoped=true"
import script from "./Instruments.vue?vue&type=script&lang=js"
export * from "./Instruments.vue?vue&type=script&lang=js"

import "./Instruments.vue?vue&type=style&index=0&id=582339be&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582339be"]])

export default __exports__